<template>
  <div id="basic_info">
    <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="104px" class="basic-info-form">
      <el-form-item label="用户头像：" class="avatar-form-item">
        <div class="personal_info avatar-field" >
          <ossUploadFile
            :class="{picUploader: infoForm.touxiang}"
            fileDir="upload/avatar"
            accept="image/jpeg, image/png"
            list-type="picture-card"
            :show-file-list="false"
            :limits="1"
            @upload="upload"
          >
            <template slot='default'>
              <div class="avatar-upload-inner">
                <img
                  v-if="infoForm.touxiang"
                  :src="infoForm.touxiang"
                  class="basicInfo-avatar"
                  @error="$event.target.src = require('@/assets/logo/logo.svg');$event.target.classList.add('default_avatar')">
                <div v-else class="basicInfo-avatar avatar-placeholder">
                  <img class="default_avatar" src="@/assets/logo/logo.svg" alt="">
                </div>
                <div class="avatar-mask">
                  <i class="el-icon-camera"></i>
                </div>
              </div>
              <el-button size="small" type="primary" class="basicInfo-upload-btn">{{ elUploadBtn }}</el-button>
            </template>
          </ossUploadFile>
          <!-- <el-upload
            action="#"
            class="basicInfo-uploader"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="avatarChange">
            <img v-if="imageUrl" :src="imageUrl" class="basicInfo-avatar">
            <img v-else-if="infoForm.touxiang" :src="infoForm.touxiang" class="basicInfo-avatar">
            <i v-else class="el-icon-plus basicInfo-uploader-icon"></i>
            <el-button size="small" type="primary" class="basicInfo-upload-btn">{{ elUploadBtn }}</el-button>
          </el-upload> -->
        </div>
      </el-form-item>
      <el-form-item label="手机号：" class="userPhone"  prop="ph_num">
        <div class="phone_info">
          {{this.infoForm.ph_num}}
          <router-link tag="span" :to="{name:'ChangeTelphone'}" class="changePhone">
            换绑手机号
          </router-link>
        </div>
      </el-form-item>
      <el-form-item label="游严选ID：" >
        <div class="user_sn">
          {{ $store.state.userData.user_sn }}
          <span @click="copy($store.state.userData.user_sn)"><span class="iconfont pxb7-copy"></span>复制</span>
        </div>
      </el-form-item>
      <el-form-item label="昵称："  prop="account">
        <el-input placeholder="请输入昵称" v-model="infoForm.account" ></el-input>
      </el-form-item>
      <el-form-item label="邮箱："  prop="email">
        <el-input placeholder="请确认邮箱" v-model="infoForm.email" ></el-input>
      </el-form-item>
      <el-form-item label="QQ号："  prop="qq_num">
        <el-input placeholder="请确认QQ号" v-model="infoForm.qq_num" ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-row">
      <div class="submit_btn" @click="submitForm('infoForm')">提交信息</div>
    </div>
    <input type="text" id="input"/>
  </div>
</template>
<script>
import {apiUserSave, apiUploadPage, apiuserInfo,apiUploadAvatar} from "@/request/API";
import chatApi from '@/request/customer/customerRoom'
import ossUploadFile from '@/components/ossUploadFile/index.vue'
import { updateUserInfo } from "../../../../request/im";

export default {
  name: '',
  props: {
  },
  components: {
    ossUploadFile
  },
  data () {
    return {
      //头像
      imageUrl: '',
      //完整头像地址
      file_path:'',
      //上传按钮文本
      elUploadBtn:'点击上传',
      //表单
      infoForm:{
        account:this.$store.state.userData.nickname,
        ph_num:this.$store.state.userData.telphone,
        email:this.$store.state.userData.email,
        qq_num:this.$store.state.userData.qq,
        touxiang:this.$store.state.userData.touxiang,
      },
      //表单验证
      rules: {
        account:[
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min: 1, max: 15, message: '请输入1-15个字符的昵称', trigger:['change','blur'] }
        ],
        email: [
          { pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/, message: '邮箱格式错误'}
        ],
        qq_num: [
          { pattern: /^[1-9][0-9]{4,9}$/, message: 'QQ账号格式错误'}
        ],
      },
      fileList:[{URL:this.$store.state.userData.touxiang}],
    }
  },
  methods: {
   //图片上传
    upload(url) {
      this.fileList=[url]
      this.infoForm.touxiang=url
      this.imageUrl=url
    },
    /**
     * 头像上传
     */
    // avatarChange(file) {
    //   console.log(file);
    //   const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
    //   const isLt5M = file.size / 1024 / 1024 < 5;
    //   if (!isJPG) {
    //     this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
    //     return
    //   }
    //   if (!isLt5M) {
    //     this.$message.error('上传头像图片大小不能超过 5MB!');
    //     return
    //   }
    //   let data = new FormData()
    //   data.append('file', file.raw)
    //   apiUploadAvatar(data).then(res => {
    //     this.infoForm.touxiang = res.data.file_path
    //   }).catch(err => {
    //     this.$message({
    //       type: "error",
    //       center: true,
    //       message: err.msg + '(5M以内的png或jpg格式的图片)'
    //     })
    //   })
    // },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiUserSave({
            nickname:this.infoForm.account,
            phone:this.infoForm.ph_num,
            qq:this.infoForm.qq_num,
            email:this.infoForm.email,
            touxiang:this.infoForm.touxiang
          }).then(res=>{
            this.$message({
              message:"提交成功",
              type:"success",
              center:true
            })
            let userData = this.$store.state.userData
            userData.touxiang = this.file_path
            userData.telphone = this.infoForm.ph_num
            userData.nickname = this.infoForm.account
            this.$store.commit('set_userData', userData)
            apiuserInfo({
              action:'base'
            }).then(res=>{
              this.$store.commit('user_BasicInfo',res.data)
            })
            // 更新用户im相关信息
            updateUserInfo({
              user_id: JSON.parse(localStorage.getItem('USER_IM_INFO')).user_id,
              name: userData.nickname,
              portrait: this.infoForm.touxiang
            })
            // 更新用户信息
            chatApi.updatecustomerinfo({
              msg: chatApi.encryptMsg({
                customerid: this.infoForm.ph_num,
                format: 'json',
                headimg: this.infoForm.touxiang?this.infoForm.touxiang:'https://images.pxb7.com/images/upload/avatar/20221009/1665300146651430.png',
                nickname: this.infoForm.account
              })
            }).then().catch()
          }).catch(err=>{
            this.$message({
              message:err.msg,
              type:"error",
              center:true
            })
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 获取基本信息
     */
    getBasicInfo(){
      apiuserInfo({
        action:'base'
      }).then(res=>{
        this.infoForm.ph_num = res.data.telphone
        this.infoForm.email = res.data.email
        this.infoForm.account = res.data.nickname
        this.infoForm.qq_num = res.data.qq
        this.infoForm.touxiang = res.data.touxiang
        this.fileList = [{url:res.data.touxiang}]
      })
    },

    /**
     * 复制功能
     * @param text
     */
    copy(text){
      var text = text;
      var input = document.getElementById("input");
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行浏览器复制命令
      this.$message({
        type: "success",
        center: true,
        message: '复制成功'
      })
    }
  },
  mounted () {
    this.getBasicInfo()
  },
  watch: {
    imageUrl(){
      if (this.imageUrl !== '') {
        this.elUploadBtn = '重新上传'
      }
    }
  },
  computed: {
  },
  created() {
    if (localStorage.getItem('loginStatus') == "true") {
      this.infoForm.account = JSON.parse(localStorage.getItem('userData')).nickname
      this.infoForm.ph_num = JSON.parse(localStorage.getItem('userData')).telphone
      this.infoForm.email = JSON.parse(localStorage.getItem('userData')).email
      this.infoForm.qq_num = JSON.parse(localStorage.getItem('userData')).qq
      this.infoForm.touxiang = JSON.parse(localStorage.getItem('userData')).touxiang
    }
  }
}
</script>

<style lang='less' scoped>
#input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: -10;
}

#basic_info{
  width: 100%;
  min-height: 520px;
  padding: 32px 44px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .basic-info-form{
    display: table;
    width: auto;
    max-width: 100%;
    margin: 0 auto;
  }

  /deep/.el-form-item{
    min-height: 40px;
    margin-bottom: 22px;
  }

  /deep/.el-form-item__label{
    padding: 0 16px 0 0;
    text-align: right;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 40px;
  }

  /deep/.el-form-item__content{
    min-height: 40px;
    line-height: 40px;
  }

  /deep/.el-input{
    width: 360px;
    max-width: 100%;
  }

  /deep/.el-input__inner{
    width: 100%;
    height: 40px;
    padding: 0 14px;
    background: var(--bg-tag, #F7F5F2);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
  }

  /deep/.el-input__inner:hover{
    border-color: var(--border-strong, #D8D2CA);
    background: #FFFFFF;
  }

  /deep/.el-input__inner:focus{
    border-color: var(--primary, #FF5A1F);
    background: #FFFFFF;
    box-shadow: none;
  }

  /deep/.is-error .el-input__inner{
    border-color: var(--danger, #EF4444);
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08);
  }

  .avatar-form-item{
    min-height: 92px;
    margin-bottom: 26px;

    /deep/.el-form-item__label{
      line-height: 84px;
    }

    /deep/.el-form-item__content{
      min-height: 84px;
      line-height: normal;
    }
  }

  .personal_info{
    min-height: 40px;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
  }

  .avatar-field{
    min-height: 84px;
  }

  /deep/.el-upload--picture-card{
    width: 236px;
    height: 84px;
    display: flex;
    align-items: center;
    gap: 18px;
    border: none;
    border-radius: 4px;
    background: transparent;
    line-height: normal;
    cursor: pointer;
  }

  /deep/.el-upload--picture-card:hover .avatar-upload-inner{
    border-color: var(--bg-dark, #1A1D24);
    box-shadow: 0 8px 20px rgba(26, 29, 36, 0.14);
  }

  /deep/.el-upload--picture-card:hover .avatar-mask{
    opacity: 1;
  }

  .avatar-upload-inner{
    position: relative;
    width: 84px;
    height: 84px;
    flex: 0 0 84px;
    padding: 3px;
    border-radius: 50%;
    border: 1px solid var(--border-soft, #E8E4DE);
    background: #FFFFFF;
    box-shadow: 0 8px 18px rgba(26, 29, 36, 0.08);
    overflow: hidden;
    transition: border-color .2s ease, box-shadow .2s ease;
  }

  .basicInfo-avatar {
    width: 76px;
    height: 76px;
    display: block;
    border-radius: 50%;
    object-fit: cover;
    background: var(--bg-tag, #F0EDE8);
  }

  .avatar-placeholder{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .default_avatar{
    width: 100%;
    height: 100%;
    padding: 14px;
    box-sizing: border-box;
    object-fit: contain;
    background: var(--bg-tag, #F0EDE8);
  }

  .avatar-mask{
    position: absolute;
    inset: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(17, 24, 39, 0.38);
    color: #FFFFFF;
    font-size: 20px;
    opacity: 0;
    transition: opacity .2s ease;
  }

  .basicInfo-upload-btn{
    width: 104px;
    height: 34px;
    padding: 0;
    border: none;
    border-radius: 3px;
    background: var(--primary, #FF5A1F) !important;
    box-shadow: none;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 34px;
    text-align: center;
    transition: background .2s ease;
  }

  .basicInfo-upload-btn:hover{
    background: var(--primary-hover, #E84A12) !important;
  }

  .phone_info{
    display: flex;
    align-items: center;
    min-height: 40px;
    gap: 16px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);

    .changePhone{
      display: inline-block;
      min-width: 104px;
      height: 34px;
      padding: 0 16px;
      border-radius: 3px;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      background: #FFFFFF;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #1A1D24);
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, border-color .2s ease;
    }

    .changePhone:hover{
      border-color: var(--bg-dark, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }
  }

  .user_sn{
    display: flex;
    align-items: center;
    min-height: 40px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);

    span{
      display: inline-flex;
      align-items: center;
      height: 28px;
      margin: 0 0 0 18px;
      padding: 0;
      border-radius: 4px;
      background: transparent;
      cursor: pointer;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-muted, #9AA0AC);
      transition: color .2s ease;

      .iconfont{
        margin: 0 4px 0 0;
        font-size: 13px;
      }
    }

    span:hover{
      color: var(--text-main, #1A1D24);

      .iconfont{
        color: var(--text-main, #1A1D24);
      }
    }
  }

  .submit-row{
    width: 560px;
    max-width: 100%;
    display: flex;
    justify-content: center;
  }

  .submit_btn{
    margin: 8px 0 0 0;
    width: 200px;
    height: 42px;
    line-height: 42px;
    background: var(--primary, #FF5A1F);
    border-radius: 3px;
    box-shadow: none;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
    transition: background .2s ease;
  }

  .submit_btn:hover{
    background: var(--primary-hover, #E84A12);
  }
}
</style>
